import { render } from "./CookieBanner.vue?vue&type=template&id=18fb07fa"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=18fb07fa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__